
<div class="wrap">
  @if (showHeader()) {
    <loyaltic-header></loyaltic-header>
  }
  <router-outlet></router-outlet>
</div>

@if (showHeader()) {
  <loyaltic-footer></loyaltic-footer>
}

<loyaltic-modal-dialog modalId="rules"></loyaltic-modal-dialog>


